import React from 'react';

const InvoiceProviderPage = React.lazy(() => import('pages/InvoiceProvider/pages/InvoiceProviderPage'));

const invoiceProviderRoute = [
  {
    path: '/invoice-provider',
    exact: true,
    name: 'Kết nối hóa đơn điện tử',
    function: 'SL_INVOICE_VIEW',
    component: InvoiceProviderPage,
  },
];

export default invoiceProviderRoute;
